import { useMutation, useQueryClient } from '@tanstack/react-query'

import { api } from '@/lib/api-client'
import { MutationConfig } from '@/lib/react-query'

export type PlanFeatureDetail = {
    featureId: string
    featureKey: string
    description: string
    unit: string
    features: (unknown | null)[]
}

export type PlanFeature = {
    planId: string
    featureId: string
    limitType: string
    limitInt: number
    limitDecimal: number
    resetPeriod: string
    pooledScope: string
    rollover: string
    gracePercent: number
    throttleAfter: number
    feature: PlanFeatureDetail
}

export type UpdatePlanInput = {
    id: string
    planSku: string
    name: string
    description: string
    billingInterval: string
    isAddon?: boolean
    features: PlanFeature[]
}

export const editPlan = (data: UpdatePlanInput): Promise<any> => {
    const { id, ...payload } = data
    return api.put(`/v2/plans/${id}`, payload)
}

type UseEditPlanOptions = {
    mutationConfig?: MutationConfig<typeof editPlan>
}

export const useEditPlan = ({ mutationConfig }: UseEditPlanOptions = {}) => {
    const queryClient = useQueryClient()
    const { onSuccess, ...restConfig } = mutationConfig || {}

    return useMutation({
        mutationFn: editPlan,
        onSuccess: (...args) => {
            queryClient.invalidateQueries({ queryKey: ['plans'], refetchType: 'active' })
            onSuccess?.(...args)
        },
        ...restConfig,
    })
}


